(function () {
  function initPricingToggles(root) {
    root.querySelectorAll('.sst-pricing-card__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var body = btn.nextElementSibling;

        btn.setAttribute('aria-expanded', String(!expanded));

        if (expanded) {
          body.hidden = true;
        } else {
          body.hidden = false;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPricingToggles(document);
    });
  } else {
    initPricingToggles(document);
  }
})();
